// React components
import { useState, useEffect, useContext } from "react";
import partCodesService from "services/part-code-service";
import changeLogService from "services/change-log-service";
import { AuthContext } from "context";

// MUI and Material Dashboard Components
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";



export default function AddToAssembly({
    handleClose,
    open,
    reloadDataTable,
    id
}) {
    const [comment, setComment] = useState("");
    const authContext = useContext(AuthContext);
    useEffect(() => {
        console.log(comment);
        console.log(id);
    }, [comment]);

    // Behaviour when clicking the reject part button
    const rejectPartHandler = async () => {
        try {

            await partCodesService.rejectPart(id);

            const changeLog = {
                data: {
                    attributes: {
                        partCode: id,
                        change: {
                            type: "Rejected",
                            description: "Part Code Rejected",
                            date: new Date(),
                            comment: comment,
                            user: await authContext.getCurrentUser()
                        }
                    }
                }
            }
            console.log(changeLog);
            await changeLogService.addChange(changeLog);
            console.log("Test 2");
            // Reload the dataTable
            if (reloadDataTable) {
                reloadDataTable(id);
            }
            handleCloseModal("rejected");
        }
        catch (error) {
            console.log(error);
        }
    }

    const handleCloseModal = (status) => {
        setComment("");
        if (status === "rejected") {
            handleClose("rejected");
        } else {
            handleClose();
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Please provide a reason to reject the part : </DialogTitle>
            <DialogContent>
                <MDBox margin={2}>

                    {/* Quantity Field */}
                    <MDBox >
                        <MDInput
                            label="Reason for Rejection"
                            name="Rejection Reason"
                            type="text"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            variant="standard"
                            fullWidth
                            multiline
                        />
                    </MDBox>

                </MDBox>
            </DialogContent>

            <DialogActions>

                <MDButton color="info" variant="gradient" size="small" onClick={handleCloseModal}>Cancel</MDButton>
                <MDButton color="error" variant="gradient" size="small" onClick={rejectPartHandler}>Reject</MDButton>

            </DialogActions>

        </Dialog>
    )
}
